import { ref } from "vue"
import type { Message as ChatMessage } from "~/stores/messages"

// Module-level singleton, matching `useMessageEditing.ts`'s pattern.
const forwardingMessage = ref<ChatMessage | null>(null)
const selectedChannelIds = ref<string[]>([])

export function useMessageForward() {
  function isForwarding(): boolean {
    return forwardingMessage.value !== null
  }

  function start(message: ChatMessage) {
    forwardingMessage.value = message
    selectedChannelIds.value = []
  }

  function toggleChannel(channelId: string) {
    const i = selectedChannelIds.value.indexOf(channelId)
    if (i === -1) selectedChannelIds.value.push(channelId)
    else selectedChannelIds.value.splice(i, 1)
  }

  function cancel() {
    forwardingMessage.value = null
    selectedChannelIds.value = []
  }

  return { forwardingMessage, selectedChannelIds, isForwarding, start, toggleChannel, cancel }
}
